var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidebarTest'),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('NotificationList'),_c('v-tour',{attrs:{"name":"myTour","steps":_vm.steps,"options":_vm.myOptions,"callbacks":_vm.vTourCallbacks}}),_c('v-tour',{attrs:{"name":"tmzTour","steps":_vm.tmzTourSteps,"options":_vm.myOptions,"callbacks":_vm.vTourCallbacks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }